export default "__VITE_ASSET__BZs6NDOH__"